const MAX_CHARS = 6000;
let contextBuffer = "";
let transcriptHistory = [];

export function appendToContext(newText, timestamp) {
  const entry = `[${timestamp}] ${newText}`;
  transcriptHistory.push(entry);
  contextBuffer += "\n" + entry;
  if (contextBuffer.length > MAX_CHARS) {
    contextBuffer = contextBuffer.slice(contextBuffer.length - MAX_CHARS);
  }
}

export function getContext() { return contextBuffer; }
export function getHistory() { return [...transcriptHistory]; }
export function clearContext() { contextBuffer = ""; transcriptHistory = []; }